// Campus photo for /colleges/university-of-kentucky: CC0 1.0, by Daderot, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AMain_Building_-_University_of_Kentucky_-_DSC09119.JPG), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-kentucky/; credited under the photo.
const photo = {
    "slug": "university-of-kentucky",
    "alt": "The brick Main Building with its central tower and lawn at the University of Kentucky in Lexington, Kentucky",
    "src": "/colleges/university-of-kentucky/campus-1600.webp",
    "srcSmall": "/colleges/university-of-kentucky/campus-800.webp",
    "srcMid": "/colleges/university-of-kentucky/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-kentucky/og.jpg",
    "title": "Main Building - University of Kentucky - DSC09119",
    "author": "Daderot",
    "license": "CC0 1.0",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AMain_Building_-_University_of_Kentucky_-_DSC09119.JPG",
    "read": "2026-10-02"
};

export default photo;
